(function () {
  var config = window.BloomingfulAffiliateContinuation || {};
  var endpoint = String(config.endpoint || "https://bloomingful-back-in-stock.onrender.com/api/affiliate/continuation").replace(/\/$/, "");
  var promoKey = "bloomingful:affiliatePromo";
  var firstTouchKey = "bloomingful:affiliateFirstTouch";
  var favoriteKey = "bloomingful:favorites";
  var sentKey = "bloomingful:coneContinuationSent";
  var dismissedKey = "bloomingful:coneContinuationDismissed";
  var restoredKey = "bloomingful:coneContinuationRestored";
  var finderDbName = "bloomingful-inspo-finder";
  var finderStore = "searches";
  var state = { eligible: false, open: false, email: "", mailto: "", summary: null, eligibleAt: 0, scrolled: false, timer: null };

  function start() {
    var continuation = new URLSearchParams(window.location.search).get("bf_continue");
    if (continuation) {
      restoreContinuation(continuation);
      return;
    }
    if (!isMobile() || isCheckout() || wasSent() || wasDismissed()) return;
    checkEligibility();
    window.setInterval(checkEligibility, 15000);
    document.addEventListener("ajaxProduct:added", delayedEligibility);
    document.addEventListener("cart:updated", delayedEligibility);
    document.addEventListener("change", delayedEligibility);
    document.addEventListener("click", function (event) {
      if (event.target.closest("[data-bf-favorite], form[action*='/cart/add']")) delayedEligibility();
    });
  }

  function delayedEligibility() {
    window.setTimeout(checkEligibility, 500);
  }

  async function checkEligibility() {
    if (state.eligible || !isConeflowerPromo() || wasSent() || wasDismissed()) return;
    var snapshot = await buildSnapshot();
    if (!snapshot.cart.length && !snapshot.favorites.length && !snapshot.finder) return;
    state.eligible = true;
    state.eligibleAt = Date.now();
    renderPrompt();
    scheduleInactivity();
    window.addEventListener("scroll", handleScroll, { passive: true });
    ["touchstart", "keydown"].forEach(function (name) {
      document.addEventListener(name, scheduleInactivity, { passive: true });
    });
  }

  function renderPrompt() {
    if (document.getElementById("BfConeContinuation")) return;
    var wrapper = document.createElement("div");
    wrapper.id = "BfConeContinuation";
    wrapper.className = "bf-cone-continuation";
    wrapper.innerHTML =
      '<button type="button" class="bf-cone-continuation__chip" data-bf-cone-open aria-haspopup="dialog">Shopping on another device?</button>' +
      '<div class="bf-cone-continuation__backdrop" data-bf-cone-backdrop hidden></div>' +
      '<section class="bf-cone-continuation__sheet" data-bf-cone-sheet role="dialog" aria-modal="true" aria-labelledby="BfConeContinuationTitle" hidden>' +
        '<button type="button" class="bf-cone-continuation__close" data-bf-cone-close aria-label="Close">x</button>' +
        '<p class="bf-cone-continuation__eyebrow">Coneflower shopping</p>' +
        '<h2 id="BfConeContinuationTitle">Continue on another device</h2>' +
        '<p class="bf-cone-continuation__copy">Email yourself a secure link to carry over your Coneflower referral and current shopping progress.</p>' +
        '<form data-bf-cone-form>' +
          '<label for="BfConeContinuationEmail">Your email</label>' +
          '<input id="BfConeContinuationEmail" type="email" inputmode="email" autocomplete="email" placeholder="you@example.com" required>' +
          '<button type="submit" class="bf-cone-continuation__submit">Send myself an email</button>' +
          '<p class="bf-cone-continuation__privacy">Your address is used only to connect this requested link. Bloomingful will not send the email or subscribe you to marketing.</p>' +
          '<p class="bf-cone-continuation__status" data-bf-cone-status role="status" aria-live="polite"></p>' +
        '</form>' +
      '</section>';
    document.body.append(wrapper);
    wrapper.querySelector("[data-bf-cone-open]").addEventListener("click", openPrompt);
    wrapper.querySelector("[data-bf-cone-close]").addEventListener("click", dismissPrompt);
    wrapper.querySelector("[data-bf-cone-backdrop]").addEventListener("click", closePrompt);
    wrapper.querySelector("[data-bf-cone-form]").addEventListener("submit", submitContinuation);
  }

  function openPrompt() {
    var root = document.getElementById("BfConeContinuation");
    if (!root || state.open) return;
    state.open = true;
    root.classList.add("is-open");
    root.querySelector("[data-bf-cone-sheet]").hidden = false;
    root.querySelector("[data-bf-cone-backdrop]").hidden = false;
    window.setTimeout(function () { root.querySelector("input").focus(); }, 50);
  }

  function closePrompt() {
    var root = document.getElementById("BfConeContinuation");
    if (!root) return;
    state.open = false;
    root.classList.remove("is-open");
    root.querySelector("[data-bf-cone-sheet]").hidden = true;
    root.querySelector("[data-bf-cone-backdrop]").hidden = true;
  }

  function dismissPrompt() {
    try { window.sessionStorage.setItem(dismissedKey, "1"); } catch (error) {}
    var root = document.getElementById("BfConeContinuation");
    if (root) root.remove();
    window.clearTimeout(state.timer);
  }

  async function submitContinuation(event) {
    event.preventDefault();
    var root = document.getElementById("BfConeContinuation");
    var form = event.currentTarget;
    var input = form.querySelector("input");
    var button = form.querySelector("button[type='submit']");
    var status = root.querySelector("[data-bf-cone-status]");
    if (!input.checkValidity()) return input.reportValidity();
    button.disabled = true;
    button.textContent = "Preparing secure link...";
    status.textContent = "";
    try {
      var promo = readJson(promoKey);
      var response = await fetch(endpoint, {
        method: "POST",
        mode: "cors",
        credentials: "omit",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(Object.assign({
          email: input.value,
          referral_token: promo && promo.token,
          continue_path: window.location.pathname + window.location.search + window.location.hash,
          snapshot: await buildSnapshot()
        }, continuationEventContext()))
      });
      var payload = await response.json().catch(function () { return {}; });
      if (!response.ok || payload.ok === false || !payload.continuation_url) throw new Error(payload.error || "Your link could not be prepared.");
      state.email = input.value.trim();
      state.summary = payload.summary || {};
      state.mailto = buildMailto(state.email, payload.continuation_url);
      try { window.localStorage.setItem(sentKey, JSON.stringify({ token: promo.token, sentAt: Date.now() })); } catch (error) {}
      closePrompt();
      window.location.href = state.mailto;
    } catch (error) {
      status.textContent = error.message || "Your link could not be prepared.";
    } finally {
      button.disabled = false;
      button.textContent = "Send myself an email";
    }
  }

  function buildMailto(email, continuationUrl) {
    var subject = "Continue my Bloomingful Coneflower shopping";
    var body = [
      "Continue shopping with your link:  ",
      continuationUrl + " ",
      "The link restores your current cart items, saved favorites, and Inspo Finder results where available. "
    ].join("\r\n");
    return "mailto:" + encodeURIComponent(email) + "?subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent(body);
  }

  function continuationEventContext() {
    var visit = readJson("bloomingful:cartMonitorVisit") || {};
    var cartTokenHash = "";
    try { cartTokenHash = window.localStorage.getItem("bloomingful:cartTokenHash") || ""; } catch (error) {}
    return {
      event_id: randomId(),
      event_at: new Date().toISOString(),
      cart_token_hash: cartTokenHash,
      theme_id: String(config.themeId || ""),
      page_path: window.location.pathname + window.location.search,
      page: {
        type: String(config.pageType || ""),
        title: document.title || "",
        path: window.location.pathname + window.location.search
      },
      visit: {
        visitor_hash: String(visit.visitor_hash || ""),
        visit_hash: String(visit.visit_hash || ""),
        visit_number: Number(visit.visit_number || 1),
        started_at: String(visit.started_at || ""),
        landing_path: String(visit.landing_path || ""),
        landing_title: String(visit.landing_title || ""),
        referrer_url: String(visit.referrer_url || ""),
        referrer_domain: String(visit.referrer_domain || ""),
        utm_source: String(visit.utm_source || ""),
        utm_medium: String(visit.utm_medium || ""),
        utm_campaign: String(visit.utm_campaign || ""),
        device_type: String(visit.device_type || ""),
        device_platform: String(visit.device_platform || ""),
        device_browser: String(visit.device_browser || ""),
        viewport_width: Number(visit.viewport_width || 0),
        viewport_height: Number(visit.viewport_height || 0)
      }
    };
  }

  async function restoreContinuation(rawToken) {
    if (!/^[A-Za-z0-9_-]{32,100}$/.test(String(rawToken || ""))) return showRestoreNotice("This shopping link is invalid.", true);
    var cleanUrl = new URL(window.location.href);
    cleanUrl.searchParams.delete("bf_continue");
    cleanUrl.searchParams.set("bf_continued", "1");
    window.history.replaceState({}, "", cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
    if (alreadyRestored(rawToken)) return;
    showRestoreNotice("Restoring your shopping progress...");
    try {
      var response = await fetch(endpoint + "/" + encodeURIComponent(rawToken), { mode: "cors", credentials: "omit", cache: "no-store" });
      var payload = await response.json().catch(function () { return {}; });
      if (!response.ok || payload.ok === false) throw new Error(payload.error || "This shopping link could not be restored.");
      storeRestoredAffiliate(payload.affiliate || {});
      var outcomes = await Promise.all([
        restoreCart(payload.snapshot && payload.snapshot.cart || []),
        restoreFavorites(payload.snapshot && payload.snapshot.favorites || []),
        restoreFinder(payload.snapshot && payload.snapshot.finder)
      ]);
      storeAffiliateOnCart(payload.affiliate || {});
      claimAffiliate(payload.affiliate || {});
      try { window.localStorage.setItem(restoredKey + ":" + rawToken.slice(0, 16), new Date().toISOString()); } catch (error) {}
      var restored = outcomes.reduce(function (sum, count) { return sum + Number(count || 0); }, 0);
      showRestoreNotice(restored ? "Your Coneflower referral and shopping progress are restored." : "Your Coneflower referral is restored.");
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { source: "affiliate-continuation" } }));
    } catch (error) {
      showRestoreNotice(error.message || "This shopping link could not be restored.", true);
    }
  }

  function storeRestoredAffiliate(affiliate) {
    var now = Date.now();
    var promo = {
      token: String(affiliate.token || ""),
      code: String(affiliate.code || "CONE"),
      referral: String(affiliate.referral || "11960885.g1rxdvzvafqbqouc"),
      landingUrl: window.location.href,
      source: "Cross-device continuation",
      startedAt: now
    };
    try {
      window.localStorage.setItem(promoKey, JSON.stringify(promo));
      window.localStorage.setItem(promoKey + ":token", promo.token);
      if (!readJson(firstTouchKey)) {
        window.localStorage.setItem(firstTouchKey, JSON.stringify({
          scope: "standard",
          startedAt: new Date(now).toISOString(),
          code: promo.code,
          token: promo.token
        }));
      }
    } catch (error) {}
  }

  function storeAffiliateOnCart(affiliate) {
    return fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: {
        bf_affiliate_code: affiliate.code || "CONE",
        bf_affiliate_referral: affiliate.referral || "11960885.g1rxdvzvafqbqOuc",
        bf_affiliate_token: affiliate.token || "",
        bf_affiliate_source: "Cross-device continuation",
        bf_affiliate_cross_device: "1"
      } })
    }).catch(function () {});
  }

  function claimAffiliate(affiliate) {
    if (!config.customerId || !affiliate.token) return;
    fetch(String(config.affiliateEndpoint || endpoint.replace(/\/continuation$/, "")) + "/claim", {
      method: "POST",
      mode: "cors",
      credentials: "omit",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: affiliate.token, customer_id: config.customerId, email: config.customerEmail || "" })
    }).catch(function () {});
  }

  async function restoreCart(items) {
    if (!items.length) return 0;
    var current = await fetch("/cart.js", { credentials: "same-origin", cache: "no-store" }).then(function (response) { return response.json(); });
    var quantities = new Map();
    (current.items || []).forEach(function (item) {
      quantities.set(cartSignature(item), (quantities.get(cartSignature(item)) || 0) + Number(item.quantity || 0));
    });
    var restored = 0;
    for (var index = 0; index < items.length; index += 1) {
      var item = items[index];
      var difference = Number(item.quantity || 0) - Number(quantities.get(cartSignature(item)) || 0);
      if (difference <= 0) continue;
      try {
        var body = { id: Number(item.variant_id), quantity: difference };
        if (item.properties && Object.keys(item.properties).length) body.properties = item.properties;
        if (item.selling_plan) body.selling_plan = Number(item.selling_plan);
        var response = await fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body)
        });
        if (response.ok) restored += difference;
      } catch (error) {}
    }
    return restored;
  }

  function cartSignature(item) {
    var properties = item.properties && typeof item.properties === "object" ? item.properties : {};
    var sellingPlan = item.selling_plan || item.selling_plan_id || item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id || "";
    return String(item.variant_id || item.id || "") + "|" + JSON.stringify(Object.keys(properties).sort().map(function (key) { return [key, properties[key]]; })) + "|" + String(sellingPlan || "");
  }

  function restoreFavorites(items) {
    if (!items.length) return 0;
    var current = readJson(favoriteKey);
    if (!Array.isArray(current)) current = [];
    var ids = new Set(current.map(function (item) { return String(item.id || ""); }));
    var added = 0;
    items.forEach(function (item) {
      if (!item.id || ids.has(String(item.id))) return;
      current.push(item);
      ids.add(String(item.id));
      added += 1;
    });
    try { window.localStorage.setItem(favoriteKey, JSON.stringify(current)); } catch (error) {}
    return added;
  }

  async function restoreFinder(finder) {
    if (!finder || !finder.search_id || !finder.image_data_url || !finder.payload) return 0;
    var db = await openFinderDb();
    await idbRequest(db.transaction(finderStore, "readwrite").objectStore(finderStore).put({
      id: "continued-" + finder.search_id,
      createdAt: Date.now(),
      fileName: finder.file_name || "Continued inspiration",
      width: Number(finder.width || 1),
      height: Number(finder.height || 1),
      dataUrl: finder.image_data_url,
      payload: finder.payload,
      scope: finder.scope || "all"
    }));
    return 1;
  }

  async function buildSnapshot() {
    var results = await Promise.all([currentCart(), currentFinder()]);
    return { cart: results[0], favorites: currentFavorites(), finder: results[1] };
  }

  function currentCart() {
    return fetch("/cart.js", { credentials: "same-origin", cache: "no-store" })
      .then(function (response) { return response.ok ? response.json() : { items: [] }; })
      .then(function (cart) {
        return (cart.items || []).map(function (item) {
          return {
            variant_id: item.variant_id,
            quantity: item.quantity,
            properties: item.properties || {},
            selling_plan: item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id || ""
          };
        });
      }).catch(function () { return []; });
  }

  function currentFavorites() {
    var items = readJson(favoriteKey);
    return Array.isArray(items) ? items : [];
  }

  async function currentFinder() {
    try {
      var db = await openFinderDb();
      var rows = await idbRequest(db.transaction(finderStore, "readonly").objectStore(finderStore).getAll());
      var entry = rows.filter(function (item) { return item && item.payload && item.payload.search_id; })
        .sort(function (a, b) { return Number(b.createdAt || 0) - Number(a.createdAt || 0); })[0];
      return entry ? {
        search_id: entry.payload.search_id,
        file_name: entry.fileName,
        width: entry.width,
        height: entry.height,
        scope: entry.scope,
        payload: entry.payload
      } : null;
    } catch (error) {
      return null;
    }
  }

  function openFinderDb() {
    return new Promise(function (resolve, reject) {
      if (!window.indexedDB) return reject(new Error("Finder history unavailable."));
      var request = window.indexedDB.open(finderDbName, 1);
      request.onupgradeneeded = function () {
        if (!request.result.objectStoreNames.contains(finderStore)) request.result.createObjectStore(finderStore, { keyPath: "id" });
      };
      request.onsuccess = function () { resolve(request.result); };
      request.onerror = function () { reject(request.error || new Error("Finder history unavailable.")); };
    });
  }

  function idbRequest(request) {
    return new Promise(function (resolve, reject) {
      request.onsuccess = function () { resolve(request.result); };
      request.onerror = function () { reject(request.error || new Error("Storage request failed.")); };
    });
  }

  function showRestoreNotice(text, error) {
    var notice = document.getElementById("BfConeRestoreNotice");
    if (!notice) {
      notice = document.createElement("div");
      notice.id = "BfConeRestoreNotice";
      notice.className = "bf-cone-restore-notice";
      notice.setAttribute("role", "status");
      notice.setAttribute("aria-live", "polite");
      document.body.append(notice);
    }
    notice.classList.toggle("is-error", Boolean(error));
    notice.textContent = text;
    if (!/Restoring/.test(text)) window.setTimeout(function () { notice.classList.add("is-settled"); }, 6500);
  }

  function scheduleInactivity() {
    window.clearTimeout(state.timer);
    state.timer = window.setTimeout(function () {
      if (state.eligible && !state.open && !wasSent() && !wasDismissed()) openPrompt();
    }, 35000);
  }

  function handleScroll() {
    if (window.scrollY > 500) state.scrolled = true;
    if (state.scrolled && window.scrollY < 80 && Date.now() - state.eligibleAt > 12000 && !state.open && !wasSent() && !wasDismissed()) {
      openPrompt();
      window.removeEventListener("scroll", handleScroll);
    }
  }

  function isConeflowerPromo() {
    var promo = readJson(promoKey);
    return Boolean(promo && promo.token && (String(promo.code || "").toUpperCase() === "CONE" || String(promo.referral || "").toLowerCase() === "11960885.g1rxdvzvafqbqouc"));
  }

  function wasSent() {
    var sent = readJson(sentKey);
    var promo = readJson(promoKey);
    return Boolean(sent && promo && sent.token === promo.token);
  }

  function wasDismissed() {
    try { return window.sessionStorage.getItem(dismissedKey) === "1"; } catch (error) { return false; }
  }

  function alreadyRestored(token) {
    try { return Boolean(window.localStorage.getItem(restoredKey + ":" + String(token).slice(0, 16))); } catch (error) { return false; }
  }

  function readJson(key) {
    try { return JSON.parse(window.localStorage.getItem(key) || "null"); } catch (error) { return null; }
  }

  function randomId() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    var bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return Array.prototype.map.call(bytes, function (byte) { return byte.toString(16).padStart(2, "0"); }).join("");
  }

  function isMobile() {
    return window.matchMedia && window.matchMedia("(max-width: 767px)").matches;
  }

  function isCheckout() {
    return window.location.pathname.indexOf("/checkout") === 0 || window.location.pathname.indexOf("/checkouts/") === 0;
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
}());
